export default (price, currency = 'usd') => {
  if (isNaN(price)) {
    return '';
  }
  const usdToLocale = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
  });

  return usdToLocale.format(price);
};
